<template>
  <div v-if="$auth.isLoggedIn">
    <div class="d-flex justify-center">
      <div
        class="profile_picture"
        :class="{
          premium: $auth.user.benefit?.active,
          prolong: isInWarningStateOfBenefit,
          authorize: isInErrorStateOfBenefit
        }"
      >
        <v-img
          class="mx-auto rounded-circle"
          :class="listenToClick ? 'cursor-pointer' : ''"
          :width="size"
          :height="size"
          cover
          :src="$asset(`img/${iconSource}.svg`)"
          @click="listenToClick ? $emit('click') : ''"
        />
      </div>
    </div>
    <div
      v-if="showBadge"
      class="premium_holder text-uppercase rounded-pill px-2 py-1 mt-n4"
      :class="[
        backgroundClass,
        {
          'white--text': $auth.user.benefit.active || hadBenefitBefore
        }
      ]"
    >
      {{ $t(`profileSection.badge.${$auth.user.benefit.active ? 'premium' : 'self'}`) }}
    </div>
  </div>
</template>

<script>
import reauthorization from '~/mixins/reauthorization.js';
import { mapGetters } from 'vuex';
import handleBenefitViews from '~/mixins/handleBenefitViews.js';
export default {
  name: 'ProfilePicture',
  mixins: [reauthorization, handleBenefitViews],
  props: {
    size: {
      type: [Number, String],
      default: 80
    },
    showBadge: {
      type: Boolean,
      default: false
    },
    listenToClick: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      shouldSeeReauthorization: 'profile/reauthorization/shouldSeeReauthorization'
    }),
    iconSource() {
      return this.isBenefitEndingInMonth || this.hadBenefitBefore
        ? `${this.reauthorizationCase}_${this.genderAwareIcon}`
        : this.genderAwareIcon;
    },
    backgroundClass() {
      if (!this.$auth.user.benefit.active && !this.hadBenefitBefore) {
        return 'grey-lighten';
      }

      if (this.isInWarningStateOfBenefit) {
        return 'warning-benefit';
      }

      if (this.isInErrorStateOfBenefit) {
        return 'error-benefit';
      }

      return 'primary';
    }
  }
};
</script>

<style lang="scss" scoped>
.premium_holder {
  position: relative;
  font-size: $font-size-smaller1;
  line-height: $line-height-smaller1;
  letter-spacing: $letter-spacing-smaller;
  font-weight: $font-weight-semi;
}
.warning-benefit {
  background-color: $warning-darken !important;
}
.error-benefit {
  background-color: $error !important;
}
</style>
